import React from 'react'
import { AccessibilityButton } from '@skillz/accessibility';
import classes from './Buttons.module.css'

const SecondaryBtn = ({dropClass, onClick, color, small, medium, large, xsmall, children, accessibilityDescription }) => {

    const handleclick = (e) => {
        e.stopPropagation()
        onClick()
    }

    return (
        <AccessibilityButton
            accessibilityDescription={accessibilityDescription}
            className={`${classes.Btn} ${classes.SecondaryBtn} ${small && classes.Small} ${medium && classes.Medium} ${large && classes.Large} ${dropClass}${xsmall ? ` ${classes.Xsmall}` : ""}`}
            onClick={(e) => handleclick(e)}
            style={{ color: color, borderColor: color }}>
            {children}
        </AccessibilityButton>
    )
}

export default SecondaryBtn;